import React, { useState } from 'react';

const API = 'https://api.botanix.in/api/sessions';

const C = {
  bg:'#F3F6F3', surface:'#FFFFFF',
  border:'#E2E8E2', border2:'#CDD8CD',
  text:'#1A2E1E', text2:'#3D5E44', text3:'#7A9A80',
  red:'#C83333', redBg:'#FDEAEA', redBorder:'#F0B8B8',
  amber:'#D4840F', amberBg:'#FEF6E7', amberBorder:'#F0D499',
  accent:'#3AAF58', accentLight:'#EAF7EE',
};

export default function MasterDelete() {
  const [show, setShow] = useState(false);
  const [step, setStep] = useState(1);
  const [confirmText, setConfirmText] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [results, setResults] = useState([]);
  const [mustChangePassword, setMustChangePassword] = useState(false);

  const reset = () => {
    setShow(false);
    setStep(1);
    setConfirmText('');
    setPassword('');
    setOtp('');
    setNewPassword('');
    setConfirmNewPassword('');
    setError('');
    setSuccess('');
    setResults([]);
    setMustChangePassword(false);
  };

  const handleVerify = async () => {
    if (confirmText !== 'DELETE ALL DATA') {
      setError('Please type DELETE ALL DATA exactly');
      return;
    }
    if (!password) { setError('Please enter password'); return; }
    if (!otp) { setError('Please enter OTP'); return; }

    setLoading(true); setError('');
    try {
      const res = await fetch(`${API}/master-delete/verify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, otp })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error); setLoading(false); return; }

      if (data.mustChangePassword) {
        setMustChangePassword(true);
        setStep(2);
      } else {
        setStep(3);
      }
    } catch(e) { setError('Connection error'); }
    setLoading(false);
  };

  const handleChangePassword = async () => {
    if (!newPassword || newPassword.length < 6) { setError('Password must be at least 6 characters'); return; }
    if (newPassword !== confirmNewPassword) { setError('Passwords do not match'); return; }

    setLoading(true); setError('');
    try {
      const res = await fetch(`${API}/master-delete/change-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ old_password: password, new_password: newPassword })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error); setLoading(false); return; }
      setSuccess('Password changed successfully!');
      setTimeout(() => { setSuccess(''); setStep(3); }, 1500);
    } catch(e) { setError('Connection error'); }
    setLoading(false);
  };

  const handleExecute = async () => {
    if (!window.confirm('THIS IS IRREVERSIBLE. All data will be permanently deleted. Are you absolutely sure?')) return;

    setLoading(true); setError('');
    try {
      const res = await fetch(`${API}/master-delete/execute`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password: newPassword || password, otp })
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error); setLoading(false); return; }
      setResults(data.results || []);
      setStep(4);
    } catch(e) { setError('Connection error'); }
    setLoading(false);
  };

  const inp = {
    width: '100%', padding: '10px 14px',
    background: '#FFF5F5', border: `1.5px solid ${C.redBorder}`,
    borderRadius: 8, color: C.text, fontSize: 14,
    boxSizing: 'border-box', marginTop: 6
  };

  if (!show) return (
    <div style={{ marginTop: 32, padding: '20px 24px', background: C.redBg, border: `1px solid ${C.redBorder}`, borderRadius: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: 800, color: C.red, marginBottom: 4 }}>Danger Zone — Master Data Reset</div>
          <div style={{ fontSize: 12, color: C.text3 }}>Permanently delete all manually entered data. Use only after testing is complete.</div>
        </div>
        <button onClick={() => setShow(true)}
          style={{ padding: '8px 16px', background: C.red, color: '#fff', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
          Reset All Data
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', zIndex: 999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: '#fff', borderRadius: 16, width: '100%', maxWidth: 480, padding: 32, boxShadow: '0 20px 60px rgba(0,0,0,.3)' }}>

        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>&#9888;</div>
          <div style={{ fontSize: 20, fontWeight: 900, color: C.red }}>Master Data Reset</div>
          <div style={{ fontSize: 13, color: C.text3, marginTop: 6 }}>
            {step === 1 && 'Step 1 of 3 — Confirm & Authenticate'}
            {step === 2 && 'Step 2 — Change Default Password'}
            {step === 3 && 'Step 3 — Final Confirmation'}
            {step === 4 && 'Reset Complete'}
          </div>
        </div>

        {error && <div style={{ padding: '10px 14px', background: C.redBg, border: `1px solid ${C.redBorder}`, borderRadius: 8, color: C.red, fontSize: 13, marginBottom: 16, fontWeight: 600 }}>{error}</div>}
        {success && <div style={{ padding: '10px 14px', background: C.accentLight, border: `1px solid ${C.accent}`, borderRadius: 8, color: C.accent, fontSize: 13, marginBottom: 16, fontWeight: 600 }}>{success}</div>}

        {/* STEP 1: Confirm + Auth */}
        {step === 1 && (
          <>
            <div style={{ padding: '14px 16px', background: C.amberBg, border: `1px solid ${C.amberBorder}`, borderRadius: 10, marginBottom: 20, fontSize: 13, color: C.amber, lineHeight: 1.6 }}>
              This will permanently delete:<br/>
              All bookings, guests, HR records, attendance, payroll, horticulture logs, construction records, social leads, loyalty data, and sales data.<br/>
              <strong>User accounts and system configuration will be kept.</strong>
            </div>

            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.text3, textTransform: 'uppercase' }}>Type exactly: DELETE ALL DATA</div>
              <input style={{ ...inp, fontFamily: 'monospace', letterSpacing: 2 }}
                value={confirmText} onChange={e => setConfirmText(e.target.value)}
                placeholder="DELETE ALL DATA" />
            </div>

            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.text3, textTransform: 'uppercase' }}>Master Password</div>
              <input style={inp} type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="Enter master password" />
            </div>

            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.text3, textTransform: 'uppercase' }}>OTP</div>
              <input style={{ ...inp, fontFamily: 'monospace', letterSpacing: 4, fontSize: 18, textAlign: 'center' }}
                type="password" value={otp} onChange={e => setOtp(e.target.value)} placeholder="••••••" maxLength={10} />
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={handleVerify} disabled={loading}
                style={{ flex: 1, padding: '12px', background: C.red, color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer', opacity: loading ? 0.6 : 1 }}>
                {loading ? 'Verifying...' : 'Verify & Continue'}
              </button>
              <button onClick={reset}
                style={{ flex: 1, padding: '12px', background: 'transparent', color: C.text2, border: `1px solid ${C.border2}`, borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                Cancel
              </button>
            </div>
          </>
        )}

        {/* STEP 2: Change Password */}
        {step === 2 && (
          <>
            <div style={{ padding: '14px 16px', background: C.amberBg, border: `1px solid ${C.amberBorder}`, borderRadius: 10, marginBottom: 20, fontSize: 13, color: C.amber }}>
              You are using the default password. Please set a new master password before proceeding.
            </div>

            <div style={{ marginBottom: 14 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.text3, textTransform: 'uppercase' }}>New Master Password</div>
              <input style={inp} type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Minimum 6 characters" />
            </div>

            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: C.text3, textTransform: 'uppercase' }}>Confirm New Password</div>
              <input style={inp} type="password" value={confirmNewPassword} onChange={e => setConfirmNewPassword(e.target.value)} placeholder="Repeat new password" />
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={handleChangePassword} disabled={loading}
                style={{ flex: 1, padding: '12px', background: C.red, color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer', opacity: loading ? 0.6 : 1 }}>
                {loading ? 'Saving...' : 'Set New Password'}
              </button>
              <button onClick={reset}
                style={{ flex: 1, padding: '12px', background: 'transparent', color: C.text2, border: `1px solid ${C.border2}`, borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                Cancel
              </button>
            </div>
          </>
        )}

        {/* STEP 3: Final Confirm */}
        {step === 3 && (
          <>
            <div style={{ padding: '20px', background: C.redBg, border: `2px solid ${C.red}`, borderRadius: 12, marginBottom: 24, textAlign: 'center' }}>
              <div style={{ fontSize: 15, fontWeight: 800, color: C.red, marginBottom: 8 }}>POINT OF NO RETURN</div>
              <div style={{ fontSize: 13, color: C.text, lineHeight: 1.7 }}>
                You are about to permanently delete all data from Botanix ERP.<br/>
                <strong>This action cannot be undone.</strong><br/>
                Make sure you have a backup if needed.
              </div>
            </div>

            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={handleExecute} disabled={loading}
                style={{ flex: 1, padding: '14px', background: C.red, color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 900, cursor: 'pointer', opacity: loading ? 0.6 : 1 }}>
                {loading ? 'Deleting...' : 'DELETE ALL DATA NOW'}
              </button>
              <button onClick={reset}
                style={{ flex: 1, padding: '14px', background: 'transparent', color: C.text2, border: `1px solid ${C.border2}`, borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                Cancel
              </button>
            </div>
          </>
        )}

        {/* STEP 4: Done */}
        {step === 4 && (
          <>
            <div style={{ textAlign: 'center', marginBottom: 20 }}>
              <div style={{ fontSize: 40, marginBottom: 12 }}>&#10003;</div>
              <div style={{ fontSize: 16, fontWeight: 800, color: C.accent }}>Data Reset Complete</div>
              <div style={{ fontSize: 13, color: C.text3, marginTop: 6 }}>All selected data has been permanently deleted.</div>
            </div>

            <div style={{ maxHeight: 200, overflowY: 'auto', marginBottom: 20 }}>
              {results.map((r, i) => (
                <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 10px', background: i%2===0 ? C.bg : '#fff', borderRadius: 6, fontSize: 12 }}>
                  <span style={{ color: C.text2, fontFamily: 'monospace' }}>{r.table}</span>
                  <span style={{ color: r.error ? C.red : C.accent, fontWeight: 600 }}>
                    {r.error ? 'Error' : `${r.deleted} deleted`}
                  </span>
                </div>
              ))}
            </div>

            <button onClick={reset} style={{ width: '100%', padding: '12px', background: C.accent, color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
              Close
            </button>
          </>
        )}
      </div>
    </div>
  );
}
